import { storage } from 'lib';
import { ICurrentEmployee } from 'store/types';

export const CURRENT_EMPLOYEE_KEY = process.env.REACT_APP_CURRENT_EMPLOYEE || 'current_employee';

const CurrentEmployeeService = {
  set: (currentEmployee: ICurrentEmployee): ICurrentEmployee => {
    storage.setItem(CURRENT_EMPLOYEE_KEY, JSON.stringify(currentEmployee));
    return currentEmployee;
  },
  get: (): ICurrentEmployee | undefined => {
    const currentEmployee = storage.getItem(CURRENT_EMPLOYEE_KEY);
    if (currentEmployee === null) return undefined;
    return JSON.parse(currentEmployee) as ICurrentEmployee;
  },
  clear: (): boolean => {
    storage.removeItem(CURRENT_EMPLOYEE_KEY);
    return true;
  },
};

export default CurrentEmployeeService;
